import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/rich/github/remapgl/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from "docz";
import Map from "./map";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "map"
    }}>{`Map`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`<Map/>`}</inlineCode>{` component creates and displays a map. The Map can be controlled and interacted with via its props. The only required prop is `}<inlineCode parentName="p">{`accessToken`}</inlineCode>{`. This is `}<a parentName="p" {...{
        "href": "https://docs.mapbox.com/help/how-mapbox-works/access-tokens/"
      }}>{`a string token provided by Mapbox`}</a>{`, you will need to create a Mapbox account to get one.`}</p>
    <p>{`A Map component can accept a number of other components as children. Data at a specific point is displayed on a map using a `}<a parentName="p" {...{
        "href": "/remapgl/docs/marker"
      }}>{`Marker`}</a>{`. Information that applies to paths or regions on a map can be applied by `}<a parentName="p" {...{
        "href": "/remapgl/docs/layer"
      }}>{`Layer`}</a>{` components.`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Map} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      